/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Publish_HeaderInputs */



/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Iconik_Publish_Publish_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_publish_header = /** @type {((inputs?: Iconik_Publish_Publish_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Publish_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Публиковать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशित करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicar")
	return /** @type {LocalizedString} */ ("Publish")
});